// The app's single source of truth for how a date or a time is SHOWN to the user.
//
// The problem this solves is width. A date renders through a fixed-width format
// ('MMM DD, YYYY' is always 12 characters) but time-of-day was being written a
// different way in almost every file that needed one -- 'h:mm a', 'h:mm A',
// 'H:mm A', 'hh:mm A', 'h:mm:ss A' were all in use at once. The unpadded ones are
// the actual defect: 'h:mm a' is 7 characters at 9:05 and 8 at 11:05, so a column
// of times ragged its left edge against the date column beside it, and the
// lowercase meridiem read lighter than the date's capitalised month.
//
// So: hours are zero-padded, the meridiem is uppercase, and seconds are never
// shown. TIME_FORMAT is 8 characters for every instant of the day.
//
// Import these instead of retyping a moment format string. A resource that passes
// no `dateFormat`/`timeFormat` already gets them -- components/Table (the `date`
// and `dateRange` column types) and components/Form/formItems (the `date` and
// `time` static renders) use them as their defaults.
export const DATE_FORMAT = 'MMM DD, YYYY';              // Aug 26, 2026
export const TIME_FORMAT = 'hh:mm A';                   // 04:10 PM
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;  // Aug 26, 2026 04:10 PM

// Year dropped, nothing else. For dense grids -- the work order trip timeline --
// where the year is noise because every stamp on the screen is the same year.
// Still fixed width.
export const SHORT_DATETIME_FORMAT = `MMM DD, ${TIME_FORMAT}`;   // Aug 26, 04:10 PM

// What you type INTO a picker, which is not what you read off a page: numeric is
// faster to key and antd parses it back. Time is the same format in both places,
// so a stamp doesn't change shape when a field flips from static to editable.
export const DATE_INPUT_FORMAT = 'MM/DD/YYYY';          // 08/26/2026
export const TIME_INPUT_FORMAT = TIME_FORMAT;           // 04:10 PM
